import React from 'react';
import { useCardStep, CardData } from './useCardStep';
import { AuthCardStepView } from './AuthCardStepView';

type AuthCardStepProps = {
    loading?: boolean;
    onCardSubmit: (card: CardData) => void;
    showNameOnCard?: boolean;
    defaultCard?: CardData;
    defaultName?: string;
    error?: string | null;
    dismissError?: () => void;
};

export const AuthCardStep: React.FC<AuthCardStepProps> = ({
    loading,
    onCardSubmit,
    showNameOnCard,
    defaultCard,
    defaultName,
    error,
    dismissError,
}) => {
    const defaultValues = defaultCard
        ? {
              nameOnCard: defaultCard.nameOnCard ?? defaultName,
              cardNumber: defaultCard.cardNumber,
              expiry: defaultCard.cardExpiryDate,
              cvv: defaultCard.cardCVV,
          }
        : undefined;

    const { register, errors, cardThumb, onSubmit } = useCardStep(
        onCardSubmit,
        showNameOnCard,
        defaultValues,
    );
    return (
        <AuthCardStepView
            register={register}
            errors={errors}
            loading={loading}
            cardThumb={cardThumb}
            showNameOnCard={showNameOnCard}
            onSubmit={onSubmit}
            error={error}
            dismissError={dismissError}
        />
    );
};
